import { render, staticRenderFns } from "./StockRegularize.vue?vue&type=template&id=1167b5d5&scoped=true"
import script from "./StockRegularize.vue?vue&type=script&lang=js"
export * from "./StockRegularize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167b5d5",
  null
  
)

export default component.exports